// extracted by mini-css-extract-plugin
export default {"appBar":"styles_appBar__8Cvy4","title":"styles_title__UTN3v","dark":"styles_dark__ZN9kZ"};